// extracted by mini-css-extract-plugin
export default {"tooltip":"CX-z","arrow":"DX-z"};